module.exports = __webpack_public_path__ + "static/img/huosu.bd2fc1da.png";